import Swiper from "swiper/swiper-bundle.min.mjs";
import "swiper/swiper.css";
import jQuery from "jquery";

/**
 * SwiperSlider class for handling Swiper functionality.
 */
export default class SwiperSlider {
  constructor() {
    // Clone of the next button for later use
    this.clonedNextButton = undefined;

    // Bind removeForm method to the current instance
    this.removeForm = this.removeForm.bind(this);

    // Check if the form is present
    if (jQuery(".formjar").length > 0) {
      // Replace form elements with Swiper structure
      this.replaceElements();

      // Place buttons in the form
      this.placeButtonsInForm();

      const swiperElement = jQuery(".swiper");
      const formJar = jQuery(".formjar");
      const buttonsWrapper = jQuery(".buttons-wrapper");
      this.showCloseButton();

      // Check if the form has already been submitted successfully
      if (
        jQuery.cookie("formSubmitted") === "1" &&
        jQuery(".frm_error_style").length === 0 &&
        jQuery(".frm_message").length === 0
      ) {
        this.removeForm(formJar);
      } else if (jQuery(".frm_message").length > 0) {
        // If there is a success message, show close button
        this.successMessage(buttonsWrapper);
      } else if (swiperElement.length > 0) {
        // If it's a swiper element, initialize Swiper
        jQuery.cookie("formSubmitted", "0", { expires: 180, path: "/" });
        this.initSwiper();
      }
    }
  }

  /**
   * Removes the form element.
   * @param {jQuery} form - The jQuery object representing the form element.
   */
  removeForm(form) {
    form.remove();
  }

  /**
   * Handles the success message state by removing buttons.
   * @param {jQuery} buttonsWrapper - The jQuery object representing the buttons wrapper.
   */
  successMessage(buttonsWrapper) {
    buttonsWrapper.remove();
    this.showCloseButton();
  }

  /**
   * Shows a close button and adds a click event to remove the form.
   */
  showCloseButton() {
    const tab = jQuery(".fj-tab");
    const form = jQuery(".formjar");

    tab.addClass("close-btn");
    tab.on("click", () => {
      if (jQuery(".frm_message").length > 0) {
        this.removeForm(form);
      }
    });
  }

  /**
   * Places buttons in the form.
   */
  placeButtonsInForm() {
    const formElement = jQuery(".formjar .fj-container .frm_forms form");
    let buttonsWrapper = jQuery(".buttons-wrapper");

    // Remove existing buttons-wrapper if found
    if (buttonsWrapper.length > 0) {
      buttonsWrapper.remove();
    }

    // Append buttons-wrapper to the form element
    if (formElement.length > 0) {
      formElement.append(buttonsWrapper);
    }
  }

  /**
   * Replaces form elements with Swiper structure.
   */
  replaceElements() {
    // Select the fieldset and swiperWrapper elements
    const fieldsetElement = jQuery(".formjar fieldset");
    const swiperWrapper = jQuery(".formjar .frm_fields_container");

    // Create the first slide element
    const firstSlide = jQuery("<div></div>")
      .text("Help deze website te verbeteren.")
      .addClass("swiper-slide first-slide");

    // Toggle classes to transform form structure into Swiper structure
    if (fieldsetElement.length > 0) {
      fieldsetElement.toggleClass("swiper", true);
      swiperWrapper.toggleClass("frm_fields_container", false);
      swiperWrapper.toggleClass("swiper-wrapper", true);

      // Insert the first slide at the beginning
      swiperWrapper.prepend(firstSlide);
      this.submitButton = jQuery(".frm_button_submit");
      this.submitButton.addClass("btn next rounded-pill");
    }
  }

  /**
   * Initializes Swiper if .swiper element exists.
   */
  initSwiper() {
    // Select the .swiper element
    const swiperElement = jQuery(".swiper")[0];

    // Check if the .swiper element exists
    if (swiperElement) {
      // Initialize Swiper with specified options
      const swiper = new Swiper(swiperElement, {
        navigation: {
          nextEl: "#next",
          prevEl: "#prev",
        },
        autoHeight: true,
      });

      // Add event listener for slide change
      swiper.on("slideChange", () => {
        // Update navigation buttons based on the current slide
        this.updateNavigationButtons(swiper);
      });

      // Execute the function on initialization to set up buttons correctly
      this.updateNavigationButtons(swiper);
    }
  }

  /**
   * Updates navigation buttons based on the current slide.
   * @param {Swiper} swiper - The Swiper instance.
   */
  updateNavigationButtons(swiper) {
    const prevButton = jQuery("#prev");
    const nextButton = jQuery("#next");

    if (nextButton.length > 0) {
      this.clonedNextButton = nextButton.clone(true);
    }

    // Toggle visibility of the previous button based on whether there is a previous slide
    if (swiper.isBeginning) {
      prevButton.css("display", "none");
    } else {
      prevButton.css("display", "block");
    }

    // Add a submit event listener to prevent form submission if required fields are empty
    jQuery("#form_enquete").submit(() => {
      if (swiper.activeIndex !== swiper.slides.length - 2) {
        return false;
      }

      // Set a cookie to mark the form as submitted
      jQuery.cookie("formSubmitted", "1", { expires: 180, path: "/" });
    });

    if (swiper.activeIndex === swiper.slides.length - 2) {
      // If it's the last slide, replace the nextButton with submitButton immediately
      if (nextButton.length > 0 && nextButton[0] !== this.submitButton[0]) {
        if (!this.submitButton.attr("type")) {
          this.submitButton.attr("type", "submit");
        }
        nextButton.replaceWith(this.submitButton);
      }
    } else {
      // If it's not the last slide, show the Next button again
      if (nextButton.length === 0) {
        this.submitButton.replaceWith(this.clonedNextButton);

        // Remove the "type" attribute if it was removed
        this.clonedNextButton.removeAttr("type");
        this.clonedNextButton.removeAttr("disabled");
        this.clonedNextButton.removeClass("swiper-button-disabled");

        // Add a click event listener to the cloned "Next" button
        this.clonedNextButton.on("click", () => {
          swiper.slideNext();
        });
      }
    }
  }
}
